export default class Router {
	constructor(routes) {
		this.routes = routes
	}

	load() {
		this.routes.forEach(route => {
			if(route.hasOwnProperty('resolve')) {
				if(document.querySelector(route.resolve)) {
					this.run(route.file)
				}
			} else {
				this.run(route.file)
			}
		});
	}

	async run(file) {
		const { default: init } = await import(`../${file}`)

		init()
	}
}